import axios from 'axios';

const apiRoot = process.env.VUE_APP_API_ROOT;
if (!apiRoot) {
  alert(
    'You need to select which API to use. Please specify an VUE_APP_API_ROOT in .env',
  );
}


const yogoApi = axios.create({
  baseURL: apiRoot,
});

yogoApi.interceptors.response.use(
  response => response.data,
);

export default yogoApi;
